export const tr = {
    cancel: 'İptal',
    save: 'todo',
    title: 'todo'
};
